import axios from 'axios';

export default function Popup() {

	let close = document.querySelector('.js-close-popup');

	if (close) {
		close.addEventListener('click', () => {
			axios
				.get('/api/popup')
				.then(response => {
					document.querySelector('.c-popup').classList.add('active');
				});
		});
	}

}
